import React from 'react';
import { Grid, Box, useMediaQuery, useTheme, Avatar } from '@mui/material';
import LoginForm from '../components/LoginForm';
import Layout from '../components/LayoutForm';
import { Link as RouterLink } from 'react-router-dom';

import { Helmet } from "react-helmet-async";

export default function HomePage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const legalLinks = (
    <Box
      sx={{
        mt: 3,
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        justifyContent: 'center',
        fontSize: '0.9rem',
      }}
    >
      <Box
        component={RouterLink}
        to="/lunchy-terminos-y-condiciones"
        sx={{ color: 'text.secondary', textDecoration: 'none' }}
      >
        Términos y condiciones
      </Box>

      <Box
        component={RouterLink}
        to="/lunchy-politicas-de-privacidad"
        sx={{ color: 'text.secondary', textDecoration: 'none' }}
      >
        Política de privacidad
      </Box>

       <Box
        component={RouterLink}
        to="/lunchy-soporte"
        sx={{ color: 'text.secondary', textDecoration: 'none' }}
      >
        Soporte
      </Box>

    </Box>
  );


  if (isMobile) {
    return (
      <Layout>

        <Helmet>
          <title>Lunchy - Backoffice</title>
        </Helmet>

        
        <Box
          sx={{
            minHeight: '100vh',
            px: 2,
            pt: 8, // Espacio arriba (ajustable según el tamaño de tu header)
            pb: 6, // Espacio abajo por estética
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start', // Puedes usar 'center' si prefieres centrado vertical
            alignItems: 'center',
          }}
        >
          <LoginForm />
          {legalLinks}
        </Box>
      </Layout>
    );
  }


  // Layout dividido para pantallas grandes
  return (
    
    <Grid container sx={{ height: '100vh', overflow: 'hidden' }}>
      
      <Helmet>
        <title>Rodaris - Iniciar sesión</title>
      </Helmet>
      
      {/* Lado Izquierdo - fijo y centrado */}
      

      {/* Lado Derecho - scrollable */}
      <Grid
        item
        md={12}
        sx={{
          height: '100vh',
          overflowY: 'auto',
          backgroundColor: '#f9f9f9',
          width: '100%',
        }}
      >
        <Box
          component={RouterLink}
          to="/"
          sx={{
            position: 'absolute',
            top: 24,
            left: 24,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            component="img"
            src="/logo.png"
            alt="Rodaris"
            sx={{
              height: 30,
              width: 'auto',
            }}
          />
        </Box>
        <Box
          sx={{
            minHeight: '100%',
            px: 4,
            py: 6,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <LoginForm />
          {/* {legalLinks} */}
        </Box>
      </Grid>
    </Grid>
  );
}
